export enum BackgroundInfoType {
  Entity = 1,
  Transaction,
  MNE,
  UncontrolledTransaction,
}
